<template>
    <div>
        <div class="px-3">
            <div class="card">
                <div class="card-header bg-primary text-white h5 m-0">
                    <page-title :title="($t('registers.participants.edit'))"></page-title>
                </div>

                <div class="card-body">
                    <!--<h1> {{id}}</h1>-->

                    <div class="form-group">
                        <label for="eventName" class="font-weight-bold">{{ $t('scheduler.gridHeaders.eventName')}}</label>
                        <input type="text" readonly class="form-control-plaintext" id="eventName" :value="participant.eventName">
                    </div>

                    <hr />

                    <person-component :person="participant.person"
                                      :allowEdit="false"
                                      :emailReadonly="false"
                                      :showSearchBox="false"
                                      :isProfileDetails="false"
                                      :requiredIdentification="false">
                    </person-component>

                    <div class="form-row">
                        <div class="form-group col-md-8 col-sm-12">

                            <div class="form-row">
                                <div class="form-group col-md-4 col-sm-12">
                                    <label class="font-weight-bold required" :for="'participationType' + _uid">{{$t("registers.events.participants.gridHeaders.participationType")}}</label>
                                    <dynamic-dropdown :apiUrl="`/api/participationType/getDropdownModels`"
                                                      v-model="participant.participationTypeId"
                                                      :id="'participationType' + _uid"
                                                      :name="'participationType' + _uid"
                                                      :required="true"
                                                      :fieldName="$t('registers.events.participants.gridHeaders.participationType')"
                                                      :filter="'contains'"
                                                      :height="500"
                                                      aria-describedby="participationTypeHelp">
                                    </dynamic-dropdown>
                                    <small id="participationTypeHelp" class="form-text text-muted">{{$t("registers.events.participants.help.participationType")}}</small>
                                </div>
                                <div class="form-group col-md-4 col-sm-12">
                                    <label class="font-weight-bold required" :for="'ralationType' + _uid">{{$t("registers.events.participants.gridHeaders.status")}}</label>
                                    <dynamic-dropdown :apiUrl="`/api/participationRelationType/getDropdownModels`"
                                                      v-model="participant.relationTypeId"
                                                      :id="'ralationType' + _uid"
                                                      :name="'ralationType' + _uid"
                                                      :required="true"
                                                      :fieldName="$t('registers.events.participants.gridHeaders.relationType')"
                                                      :filter="'contains'"
                                                      :height="500"
                                                      aria-describedby="relationTypeHelp">
                                    </dynamic-dropdown>
                                    <small id="relationTypeHelp" class="form-text text-muted">{{$t("registers.events.participants.help.participationStatus")}}</small>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-md-4 col-sm-12">
                            <div class="form-group col-12">
                                <label class="font-weight-bold" :for="'note' + _uid">{{$t('registers.events.participants.gridHeaders.note') }}</label>
                                <textarea class="form-control" rows="5"
                                          v-model="participant.note"
                                          :name="'note' + _uid"
                                          :id="'note' + _uid">
                                </textarea>
                            </div>
                        </div>
                    </div>

                    <!--<div class="form-group col-12">
                        <file-upload :model="files"
                                     @fileRemoved="fileRemoved">
                        </file-upload>
                    </div>-->

                    <div class="btn-group">
                        <button type="button" class="btn btn-lg btn-primary "
                                v-if="hasEditRights"
                                :disabled="saving"
                                @click="saveParticipant">
                            <i class="fas fa-save"></i>
                            {{$t('buttons.save.btnText')}}
                        </button>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PageTitle from '@/components/common/PageTitle';
    import PersonComponent from '@/components/person/Person'
    import { Participant } from '@/models/models';
    import DynamicDropdown from '@/components/dropdown/DynamicDropdown'

    export default {
        inject: ['$validator'],
        props: {
            id: {
                type: [Number, String],
                required: true
            },
            details: {
                type: Boolean,
                default: false
            }
        },
        components: {
            PersonComponent,
            DynamicDropdown,
            PageTitle
        },
        data() {
            return {
                participant: new Participant(),
                personSearchBoxId: '',
                saving: false,
                showParticipant: false,
                files: []
            }
        },
        mounted() {
            if (this.validId) {
                this.loadParticipant();
            }
        },
        methods: {
            loadParticipant() {
                this.$http.get(`/api/participant/getForEdit/${this.id}`).then((response => {
                    if (response.data.participant) {
                        this.participant = new Participant(response.data.participant);
                    }
                })).catch(error => {
                    this.saving = false;

                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration
                    });
                });
            },
            saveParticipant() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.saving = true;
                        if (Array.isArray(this.files) && this.files.length > 0) {
                            let tempFileIds = []
                            this.files.forEach(file => {
                                tempFileIds.push(file.tempId);
                            });

                            this.participant.tempFileIds = tempFileIds;
                        }

                        this.$http.put('/api/participant', this.participant).then((response => {
                            this.saving = false;
                            this.$emit('save', this.participant);

                            let statusCode = Number(this.$helpers.responseStatusCode(response));
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + statusCode),
                                text: this.$helpers.responseMessage(response),
                                color: statusCode === 240 ? 'warning' : 'success',
                                time: this.$store.getters.notificationDuration
                            });
                        })).catch(error => {
                            this.saving = false;

                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: this.$helpers.errorColor(error),
                                time: this.$store.getters.notificationDuration
                            });
                        });
                    }
                });
            },
        },
        watch: {

        },
        computed: {
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            },
            hasEditRights() {
                return true;
            },
            validId() {
                return !isNaN(this.id) && this.id > 0;
            }
        }
    }
</script>

<style scoped>
</style>
